import {BaseApi} from './base.api';

export const LoginApi = {
  authenticate
};

function authenticate({username, password}){
  return BaseApi.post('/authenticate', {username: username, password: password});
}
